import { useParams, useNavigate } from "react-router";

// Toolkit
import { buildRoute } from "sj-ui-toolkit/src/constants/routes.js";

// Context
import { TournamentContextProvider } from "../../context/TournamentContext";

// Sub-components
import TournamentLesson from "./Components/TournamentLesson.jsx";

/**
 * TournamentContentPage Component
 *
 * Displays a specific content item (exercise/challenge) within a tournament.
 * This component handles the rendering of tournament exercises and challenges
 * with their associated content, instructions, and submission interfaces.
 *
 * Route params:
 * - tournamentId: The ID of the tournament
 * - contentType: The type of content (e.g., "Lesson", "Experiment")
 * - contentId: The unique key for the content item
 */
export default function TournamentContentPage() {
  const { tournamentId, contentType, contentId } = useParams();

  // Navigate back to tournament page on content completion
  const navigate = useNavigate();
  const onContentComplete = () => {
    navigate(buildRoute("Learn.routes.tournaments.routes.details.route", { tournamentId }));
  };

  return (
    <TournamentContextProvider
      tournamentId={tournamentId}
      contentType={contentType}
      contentId={contentId}
    >
      <div className="h-full" aria-label="Tournament Lesson Content">
        <TournamentLesson onContentComplete={onContentComplete} />
      </div>
    </TournamentContextProvider>
  );
}
